<div class="outer-wrapper">
  <!-- HANDLE TAXONOMY-SETTINGS SIGNAL-->
  <!-- IF SIGNAL IS FALSE THEN OPEN WRAPPER -->
  @if (true) {
  <div class="wrapper">
    <div class="tab-selection">
      <mat-tab-group animationDuration="0ms" disableRipple="true" (selectedTabChange)="onTabChange($event)">
        <mat-tab label="Entities Hub">
        </mat-tab>
        <mat-tab label="Playground">
        </mat-tab>
      </mat-tab-group>
    </div>

    <div class="selected-area">
      <ng-container *ngIf="selectedTabIndex === 0">
        <app-taxonomy-entity-hub-v2></app-taxonomy-entity-hub-v2>
      </ng-container>
      <ng-container *ngIf="selectedTabIndex === 1">
        <app-taxonomy-playground></app-taxonomy-playground>
      </ng-container>
    </div>
  </div>

  } @else{
  <!-- IF SIGNAL IS TRUE THEN OPEN WRAPPER -->
  <app-taxonomy-settings></app-taxonomy-settings>
  }
</div>
